import type { SelectedUrlNodeDTO } from '../../types/lac';
import type { CrawlUrlNode, WithResourceId } from '../../types/knowledge';

/** Maps LAC selected-URL DTOs onto knowledge crawl URL nodes for the shared tree. */
export function toCrawlUrlNodes(
  nodes: SelectedUrlNodeDTO[],
): Array<WithResourceId<CrawlUrlNode>> {
  return nodes.map((node, index) => {
    const url = node.url?.trim() || '';
    const id =
      node.id?.trim() ||
      (url !== '' ? `selected-url:${url}` : `selected-url:${index}`);

    return {
      id,
      url: url || undefined,
      parentId: node.parentId,
      pathSegment: node.pathSegment,
      depth: node.depth,
      lastmod: node.lastmod,
      selected: true,
    };
  });
}
